<template>
  <div id="nav">
    <router-view />
  </div>
</template>

<style lang="scss">
$pvd-class-prefix: 'pvd3';
$pvd-enable-helios-styles: true;
@import '@fmr-pr101742/providence-visual-style/styles/visual-style.scss';
@import 'pvd3/dist/scss/pvd-alert/pvd-alert.scss';
@import 'pvd3/dist/scss/pvd-button/pvd-button.scss';
@import 'pvd3/dist/scss/pvd-content-block/pvd-content-block.scss';
@import 'pvd3/dist/scss/pvd-expand-collapse/pvd-expand-collapse.scss';
@import 'pvd3/dist/scss/pvd-field-group/pvd-field-group.scss';
@import 'pvd3/dist/scss/pvd-grid/pvd-grid.scss';
@import 'pvd3/dist/scss/pvd-icon/pvd-icon.scss';
@import 'pvd3/dist/scss/pvd-inline-alert/pvd-inline-alert.scss';
@import 'pvd3/dist/scss/pvd-input/pvd-input.scss';
@import 'pvd3/dist/scss/pvd-label/pvd-label.scss';
@import 'pvd3/dist/scss/pvd-link/pvd-link.scss';
@import 'pvd3/dist/scss/pvd-list-group/pvd-list-group.scss';
@import 'pvd3/dist/scss/pvd-microcopy/pvd-microcopy.scss';
@import 'pvd3/dist/scss/pvd-modal/pvd-modal.scss';
@import 'pvd3/dist/scss/pvd-popover/pvd-popover.scss';
@import 'pvd3/dist/scss/pvd-progress-indicator/pvd-progress-indicator.scss';
@import 'pvd3/dist/scss/pvd-spinner/pvd-spinner.scss';
@import 'pvd3/dist/scss/pvd-tile/pvd-tile.scss';
@import 'pvd3/dist/scss/pvd-title/pvd-title.scss';
@import 'pvd3/dist/scss/pvd-tooltip/pvd-tooltip.scss';

#app {
  font-family: $pvd-font-family-sans;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  background-color: $pvd-background-color-white;
}

#nav {
  a {
    color: $pvd-color-palette-black;

    :-webkit-any-link {
      color: $pvd-color-palette-black;
    }

    :-moz-any-link {
      color: $pvd-color-palette-black;
    }

    :any-link {
      color: $pvd-color-palette-black;
    }

    &.router-link-exact-active {
      color: #42b983;
    }
  }

  svg.pvd-expand-collapse__icon {
    color: #368727;
  }
}
</style>
